// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { css } from '@microsoft/fast-element';
export const dataGridStyles = (context, definition) => css `
	:host {
		display: flex;
		position: relative;
		flex-direction: column;
		width: 100%;
	}
`;
